/**
 * The Lumora scrollbar: one look on every site, coloured from the site's own theme tokens. The thumb is the brand
 * colour and the track the page surface; a site can set `--scrollbar-thumb` / `--scrollbar-track` to change them.
 * Kept at normal width on purpose so people who drag the bar (often older visitors) can grab it. Elements that hide
 * their own bar (scrolling chip strips) keep doing so.
 */
export const SCROLLBAR_STYLE_ID = "lumora-scrollbar";
export const SCROLLBAR_CSS = `:root {
  --lumora-scroll-thumb: var(--scrollbar-thumb, var(--brand));
  --lumora-scroll-track: var(--scrollbar-track, var(--surface));
}
html {
  scrollbar-color: var(--lumora-scroll-thumb) var(--lumora-scroll-track);
}
::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}
::-webkit-scrollbar-track {
  background: var(--lumora-scroll-track);
}
::-webkit-scrollbar-thumb {
  background: var(--lumora-scroll-thumb);
  border: 3px solid var(--lumora-scroll-track);
  border-radius: 0;
}
::-webkit-scrollbar-corner {
  background: var(--lumora-scroll-track);
}`;
/** Adds the scrollbar style to the page once. Safe no-op without a document (SSR, tests without jsdom). */
export function installScrollbar() {
    // No document, or a stub without the DOM calls (unit tests of apps that fake `document`): nothing to style
    if (typeof document === "undefined" || typeof document.getElementById !== "function" || !document.head)
        return;
    if (document.getElementById(SCROLLBAR_STYLE_ID))
        return;
    const style = document.createElement("style");
    style.id = SCROLLBAR_STYLE_ID;
    style.textContent = SCROLLBAR_CSS;
    document.head.append(style);
}
//# sourceMappingURL=scrollbar.js.map